import { Product } from '../../../modules/product/models/Product'
import {
  emptyPatientOncologyDTO,
  fromPatientOncology,
  PatientOncologyDTO,
} from '../../../modules/patient/models/patientForm/PatientOncologyDTO'
import { useStyles } from '../Application.styles'
import { COLOR_PRIMARY } from '../../../routes/color-constants'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { FormType } from '../../../common/enums/Enums'
import { PatientOncology } from '../../../modules/patient/models/patientForm/PatientOncology'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { userGenders } from '../../../modules/users/enums/GenderType'
import { getPatientContainer } from 'container/patient-modules'
import { PatientService } from 'modules/patient/services/PatientService'
import { PATIENT_SERVICE_KEY } from 'modules/patient'
import { CLIENTS_SERVICE_KEY } from 'modules/clients'
import { ClientService } from 'modules/clients/services/ClientService'
import { getClientContainer } from 'container/client-modules'
import { Query, QueryParam } from 'common/api/Query'
import {
  emptySampleOncologyDTO,
  toModel,
} from 'modules/sampleType/models/sampleForm/SampleOncologyDTO'
import { emptySampleDTO } from 'modules/sample/models/SampleDTO'
import { v4 as uuidv4 } from 'uuid'
import { format, isValid } from 'date-fns'
import {convertTimeToLocal, formatDate } from '../../../common/utils/DataFormatters'

type RouteProps = {
  id?: string
  navigate?: () => void
}

export type FormOncologyProps = RouteProps & {
  patients: PatientOncologyDTO[]
  productIndex: number
  handleChangePatients: (productIndex: number, patients: any[], type: FormType) => void
  product: Product
  type?: string
  edit?: boolean
  clientIDDoingTheRequest: string;
  setIsOpen: (bool: boolean) => void
  setCurrentProduct: (curentProduct: number) => void
  setCurentType: (curentType: number) => void
}

const patientService = getPatientContainer().get<PatientService>(PATIENT_SERVICE_KEY)
const clientService = getClientContainer().get<ClientService>(CLIENTS_SERVICE_KEY)

export const PatientFormOncology = (props: FormOncologyProps) => {
  const patientNumber = props.product.patientNumber || 0
  const classes = useStyles({ color: COLOR_PRIMARY })
  const [patients, setPatients] = useState<PatientOncologyDTO[]>(props.patients)
  const { t, i18n } = useTranslation()
  const [selectedPatientID, setSelectedPatientID] = useState<string[]>([])
  const [previousPatients, setPreviousPatients] = useState<PatientOncology[]>([])

  useEffect(()=>{
    if (props.patients) setPatients(props.patients)
  },[props.patients])

  useEffect(() => {
    let patientsAux: PatientOncologyDTO[] = []
    let start = 0

    for (let i = start; i < patientNumber; i++) {
      if (props.patients[i]) {
          let filtered = previousPatients.filter((p)=> p.id == props.patients[i]._id)
          let auxSelected: any[] = []

          if (filtered?.length > 0) {
            if (patientNumber > 0) {
              auxSelected[0] = filtered[0].id
              patientsAux[0] = fromPatientOncology(filtered[0])
            }
    
            setSelectedPatientID(auxSelected)
          }
          patientsAux[i] = props.patients[i]
      } else {
        patientsAux[i] = emptyPatientOncologyDTO()
      }
    }

    setPatients(patientsAux)
  }, [previousPatients])

  useEffect(() => {
    if (props.patients?.length > 0) {
      let auxSelected: any[] = []
      props.patients.forEach((p, i) => {
        auxSelected[i] = p._id
      })
      setSelectedPatientID(auxSelected)
    } else {
      let auxSelected: any[] = []
      Array(patientNumber).forEach((_, i) => {
        auxSelected[i] = ''
      })
      setSelectedPatientID(auxSelected)
    }
  }, [])
  
  useEffect(() => {
    clientService.getByID(props.clientIDDoingTheRequest).subscribe(async (res) => {
      if (res) {
        let client = res

    let all = await patientService.getAllPatients(  new Query({
                  query: [new QueryParam('clientID', client.id || '')],
                })).toPromise()
      const resultArray = [...(all?.items) || []]
        let personasFiltradas: any[] = filtrarPersonas(resultArray)

        if (window.location.pathname.includes('new')) {
          personasFiltradas.forEach((persona) => {
            //@ts-ignore
            persona._sample = toModel(emptySampleDTO())
            //@ts-ignore
            persona.sample = toModel(emptySampleDTO())
          })
        }

        setPreviousPatients(personasFiltradas)
      }
    })
  }, [])

  function filtrarPersonas(personas: any[]): any[] {
    const personasFiltradas: { [key: string]: any } = {}

    personas.forEach((persona) => {
      if (personasFiltradas[persona.firstName + persona.lastName]) {
        if (persona.priority) {
          personasFiltradas[persona.firstName + persona.lastName] = persona
        }
      } else {
        personasFiltradas[persona.firstName + persona.lastName] = persona
      }
    })

    return Object.values(personasFiltradas)
  }

  const getEmptyPatients = (): PatientOncologyDTO[] => {
    const patients: PatientOncologyDTO[] = []
    if (patientNumber) {
      for (let i = 0; i < patientNumber; i++) {
        patients.push(emptyPatientOncologyDTO())
      }
    }
    return patients
  }

  useEffect(() => {
    if (
      props.type != 'view' &&
      ((props.patients !== null && props.patients?.length == 0) || props.patients == null)
    ) {
      props.handleChangePatients(props.productIndex, getEmptyPatients(), FormType.TypeFormOncology)
    }
  }, [props.product])

  useEffect(() => {
    if (props.type == 'view') {
      props.handleChangePatients(props.productIndex, props.patients, FormType.TypeFormOncology)
    }
  }, [props.type])

  const handlePatientChange = (
    index: number,
    field: keyof PatientOncology,
    value: string | Date | boolean | number
  ) => {
    const newPatients = [...patients]
    const patientToUpdate = newPatients[index]
    const updatedPatient = { ...patientToUpdate, [field]: value }

    if (!updatedPatient._id) {
      updatedPatient._id = uuidv4()
    }

    newPatients[index] = updatedPatient

    setPatients(newPatients)
    props.handleChangePatients(props.productIndex, newPatients, FormType.TypeFormOncology)
  }

  const handleSetSelectedValue = (index: number, value: string) => {
    let patientsAux = previousPatients.filter((p) => p.id == value)
    const newPatients: any[] = [...patients]

    if (patientsAux?.length > 0) {
      let patient = patientsAux[0]

      let auxElement = {
        _id: patient.id,
        _firstName: patient.firstName,
        _lastName: patient.lastName,
        _dob: patient.dob,
        _sex: patient.sex,
        _street: patient.street,
        _city: patient.city,
        _zipCode: patient.zipCode,
        _country: patient.country,
        _phone: patient.phone,
        _diagnosis: patient.diagnosis,
        _stage: patient.stage,
        _indication: patient.indication,
        _clinicHistory: patient.clinicHistory,
        _sample: patient._sample ? patient._sample : toModel(emptySampleOncologyDTO())
      }

      newPatients.splice(index, 1, auxElement)
    } else {
      newPatients.splice(index, 1, emptyPatientOncologyDTO())
    }

    setPatients(newPatients)
    props.handleChangePatients(props.productIndex, newPatients, FormType.TypeFormOncology)

    let auxSelected = [...selectedPatientID]
    auxSelected[index] = value
    setSelectedPatientID(auxSelected)
  }

  const openModal = () => {
    props.setCurrentProduct(props.productIndex)
    props.setCurentType(FormType.TypeFormOncology)
    props.setIsOpen(true)
  }

  return (
    <Grid container direction="column">
      {[...Array(patientNumber)].map((_, index) => (
        <Grid container spacing={4} key={index} style={{ marginTop: '40px' }}>
          <Grid item xs={12} style={{ textAlign: 'left', fontWeight: 'bold', fontSize: '18px' }}>
          {t('fillPatientData') + ' ' + (index + 1) + ' ' + t('for') + ' ' + (i18n.language == "es" ? props.product.nameES : props.product.nameEN)}
          </Grid>
          {props.edit !== false && (
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="typeSampleLabel">{t('selectPatient')}</InputLabel>
                <Select
                  labelId={'typeSampleLabel'}
                  id={'type'}
                  name={'type'}
                  //@ts-ignore
                  onChange={(e) => handleSetSelectedValue(index, e.target.value)}
                  style={{ width: '50%' }}
                  value={selectedPatientID?.length > index ? selectedPatientID[index] : ""}>
                  {previousPatients.map((patient, indexST) => {
                    return (
                      <MenuItem key={indexST} value={patient.id}>
                        {patient.firstName + ' ' + patient.lastName}
                      </MenuItem>
                    )
                  })}
                  <MenuItem key={''} value={''}>
                    {t('notSelect')}
                  </MenuItem>
                </Select>

                {props.productIndex > 0 && (
                <Button
                  variant="contained"
                  onClick={openModal}
                  className={classes.button}
                  style={{ display: 'flex', alignSelf: 'flex-end' }}>
                  {t("aplyPatientes")}
                </Button>)
               }
               
              </FormControl>
            </Grid>
          )}
          <Grid item xs={6}>
            <TextField
              id={`firstName-${index}`}
              label={t('name')}
              variant="filled"
              disabled={props.edit === false}
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._firstName) || ''}
              onChange={(e) => handlePatientChange(index, '_firstName', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`lastName-${index}`}
              label={t('lastName')}
              disabled={props.edit === false}
              variant="filled"
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._lastName) || ''}
              onChange={(e) => handlePatientChange(index, '_lastName', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`nhc-${index}`}
              label={t('nhc')}
              disabled={props.edit === false}
              variant="filled"
              fullWidth
              className={classes.textField}
              value={(patients && patients[index]?._dni) || ''}
              onChange={(e) => handlePatientChange(index, '_dni', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                format="dd/MM/yyyy"
                value={(patients && convertTimeToLocal(patients[index]?._dob)) || null}
                disabled={props.edit === false}
                onChange={(date) => date && isValid(date) && handlePatientChange(index, '_dob', formatDate(date))}
                label={t('dob')}
                slotProps={{
                  textField: {
                    variant: 'outlined',
                    size: 'small',
                    required: true,
                    sx: { width: '100%' },
                    id: `dob-${index}`,
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="inherit-label">{t('gender')+"*"}</InputLabel>
              <Select
                labelId="gender-label"
                id="gender"
                fullWidth
                style={{ textAlign: 'left' }}
                disabled={props.edit === false}
                value={(patients && patients[index]?._sex) || ''}
                onChange={(e) => handlePatientChange(index, '_sex', e.target.value as string)}
                label={t('gender')}>
                {Object.entries(userGenders()).map(([key, value]) => (
                  <MenuItem value={key}>{value}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`street-${index}`}
              label={t('street')}
              variant="filled"
              fullWidth
              className={classes.textField}
              disabled={props.edit === false}
              value={(patients && patients[index]?._street) || ''}
              onChange={(e) => handlePatientChange(index, '_street', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`city-${index}`}
              label={t('city')}
              variant="filled"
              fullWidth
              className={classes.textField}
              disabled={props.edit === false}
              value={(patients && patients[index]?._city) || ''}
              onChange={(e) => handlePatientChange(index, '_city', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`zipCode-${index}`}
              label={t('zipCode')}
              variant="filled"
              fullWidth
              className={classes.textField}
              disabled={props.edit === false}
              value={(patients && patients[index]?._zipCode) || ''}
              onChange={(e) => handlePatientChange(index, '_zipCode', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`country-${index}`}
              label={t('country')}
              variant="filled"
              fullWidth
              className={classes.textField}
              disabled={props.edit === false}
              value={(patients && patients[index]?._country) || ''}
              onChange={(e) => handlePatientChange(index, '_country', e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`phone-${index}`}
              label={t('phone')}
              variant="filled"
              fullWidth
              className={classes.textField}
              disabled={props.edit === false}
              value={(patients && patients[index]?._phone) || ''}
              onChange={(e) => handlePatientChange(index, '_phone', e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`diagnosis-${index}`}
              label={t('diagnosis')}
              disabled={props.edit === false}
              onChange={(event) => handlePatientChange(index, '_diagnosis', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._diagnosis) || ''}
              variant="outlined"
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`stage-${index}`}
              label={t('stage')}
              disabled={props.edit === false}
              onChange={(event) => handlePatientChange(index, '_stage', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._stage) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`indication-${index}`}
              disabled={props.edit === false}
              label={t('indication')}
              onChange={(event) => handlePatientChange(index, '_indication', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._indication) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id={`clinicHistory-${index}`}
              disabled={props.edit === false}
              label={t('clinicHistory')}
              onChange={(event) => handlePatientChange(index, '_clinicHistory', event.target.value)}
              multiline
              rows={4}
              value={(patients && patients[index]?._clinicHistory) || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}
